import { ErrorHandler, inject, Injectable } from '@angular/core';
import { NotificationService } from '../../app/common/notification.service';
import { LoadingIndicatorService } from '../../app/common/loading/loading-indicator.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AppInsightsService } from '../app-insights.service ';

@Injectable({ providedIn: 'root' })
export class ClientErrorInterceptor implements ErrorHandler {
  private notificationService = inject(NotificationService);
  private logService = inject(AppInsightsService);
  private loadingService = inject(LoadingIndicatorService);

  constructor() {}

  handleError(error: any): void {
    if(error instanceof HttpErrorResponse) {
      return;
    }
    this.logService.logError(error, 'Client: An error occurred while processing the request:');

    this.loadingService.stopAllLoading();
    let errorMessage = 'Client: A apărut o eroare. Vă rugăm să încercați din nou mai târziu.';
    this.notificationService.showError(errorMessage, 5000);
  }
}